import gql from 'graphql-tag';

export default gql`
  query GetShop($id: ID!) {
    shop(id: $id) {
      id
      name
      description
      status
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      pdfs
      tradingHours
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      hyperlinks
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetShop.ts